// Temporary feature switches. Change a value to true to restore the feature.
export const features = Object.freeze({
  chat: false
})
